import { usePlanStore } from "~/stores/PlanStore";

export const useCheckContractExpiration = () => {
  const planStore = usePlanStore();
  let prevCheckDate: Date;
  let checkTimer: any = null;
  let checkPlanId: string = "";
  // 契約期間のチェック間隔。前回のチェックからこの時間が経過していない場合はチェックしない
  const CHECK_CONTRACT_INTERVAL = 1000 * 60 * 60 * 12;
  // 定期的な実行の間隔。この間隔でチェック処理を呼び出す
  const CHECK_EXECUTION_INTERVAL = 1000 * 60;

  const checkContractExpiration = async () => {
    if (checkPlanId === "") {
      return;
    }
    // 前回のチェックからCHECK_CONTRACT_INTERVAL経過していなければチェックしない
    const now = new Date();
    const diff = now.getTime() - prevCheckDate.getTime();
    if (diff < CHECK_CONTRACT_INTERVAL) {
      return;
    }

    try {
      // 前回チェック日時を更新
      prevCheckDate = now;
      // 契約情報を取得
      const plan = await planStore.getOne(checkPlanId);
      if (!plan) {
        return;
      }
      if (!isContractPlan(plan)) {
        // 契約してなければリロードする
        window.location.reload();
      }
    } catch (e) {
      consoleLog("checkContractExpiration : error", e);
    }
  };

  const onMounted = (planId: string) => {
    // １回目の契約チェックはtalkViewの初期化で行っているので、prevCheckDateを現在時刻に設定
    prevCheckDate = new Date();
    checkPlanId = planId;
    checkTimer = setInterval(() => {
      checkContractExpiration();
    }, CHECK_EXECUTION_INTERVAL);
  };

  const onUnmounted = () => {
    if (checkTimer) {
      clearInterval(checkTimer);
      checkTimer = null;
    }
  };

  return {
    checkContractExpiration, // テスト用にexport
    onMounted,
    onUnmounted,
  };
};
